import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const PasswordsServiceContext = createContext(undefined)

const PasswordsServiceProvider = ({
  children,
  oauthApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={PasswordsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={oauthApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/auth/token`, payload)
          return data
        },
        update: async (payload) => {
          // Expect backend to return field-level errors for better UX
          // e.g., { confirm: 'Does not match' } or { old: 'Old password is incorrect' }
          const {data} = await axios.post(`/oauth/password/change`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

PasswordsServiceProvider.propTypes = {
  children: PropTypes.any,
  oauthApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const usePasswordsService = () => {
  const context = useContext(PasswordsServiceContext)
  if (context === undefined) {
    throw new Error('PasswordsServiceContext was not provided. Make sure your component is a child of the PasswordsServiceProvider.')
  }
  return context
}

export {PasswordsServiceProvider, usePasswordsService}
